<!--error-type-->

<!--not found-->

<template>
  <div class='page-404'>
    <h1>页面走丢了</h1>
  </div>
</template>

<script>
/* ============
   * 404 Page
   * ============
   */
export default {
  data() {
    return {
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
.page-404 {
  overflow: hidden;
  text-align: center;
  h1 {
    margin-top: 30px;
    font-size: 60px;
    color: transparent;
    background-image: -webkit-linear-gradient(bottom, rgb(155, 26, 214), rgb(219, 16, 16));
    background-clip: text;
    -webkit-background-clip: text;
    text-shadow: 6px 6px 10px rgb(70, 168, 185);
  }
}
</style>
